module.exports = __webpack_public_path__ + "img/v3-notes.7c851918.svg";